<script setup lang="ts">
import type {Area, Component} from "#magnolia-layer/types/magnolia-types";
import {isComponent} from "#magnolia-layer/types/api";
import {EditableComponent} from "@magnolia/vue-editor";

const props = defineProps<{
  content: Area
}>();

const components = computed(() => {
  return props.content
      ? props.content["@nodes"]
          .map((nodeName) => {
            const n = props.content[nodeName];
            if (isComponent(n)) {
              return n;
            }
          })
          .filter((n): n is Component => !!n)
      : [];
});
</script>

<template>
  <section class="inner-content-grid article-margin mb-0 lg:mb-0">
    <span class="text-2xl font-sans font-bold mb-4" v-if="content.eyebrow">{{ content.eyebrow }}</span>
    <h2 class="text-4xl uppercase mb-16" v-if="content.title">{{ content.title }}</h2>
    <template v-for="childContent in components" :key="childContent['@id']">
      <EditableComponent :content="childContent" />
    </template>
  </section>
</template>
